// extracted by mini-css-extract-plugin
module.exports = {"title":"CartForm_title__2u4Ww","form":"CartForm_form__1WP9S","formContent":"CartForm_formContent__2a3gj","formBtn":"CartForm_formBtn__1T2Mn"};